import { TransparentCard, CardContent, CardHeader, CardTitle } from "./ui/card";
import { MedalIcon, MapIcon, PlaneIcon, GiftIcon } from "../components/Icons";

interface FeatureProps {
  icon: JSX.Element;
  title: string;
  description: string;
}

const features: FeatureProps[] = [  {
    icon: <MedalIcon />,
    title: "Connect Exchanges",
    description:
      "Link your exchanges using our Setup instructions to unlock powerful trading capabilities.",
  },
  {
    icon: <MapIcon />,
    title: "Make Doyen Yours",
    description:
      "Customize Doyen with exchange and symbol preferences, hotkeys and indicators to suit your trading style.",
  },
  {
    icon: <PlaneIcon />,
    title: "Trade Your Edge",
    description:
      "Monitor markets with unparalleled information and execute trades across all exchanges.",
  },
  {
    icon: <GiftIcon />,
    title: "Master the Markets",
    description:
      "Achieve trading mastery with real-time analytics, Python algorithms, and professional-grade tools.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="howItWorks"
      className="container text-center py-24 sm:py-32"
    >      <h2 className="text-3xl md:text-4xl font-bold ">
        Your Path to{" "}
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          Mastery{" "}
        </span>
        in 4 Steps
      </h2>
      <p className="md:w-3/4 mx-auto mt-4 mb-8 text-xl text-muted-foreground">
        From passive investor to high-frequency trader, Doyen is with you every step of the way.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map(({ icon, title, description }: FeatureProps) => (
          <TransparentCard
            key={title}
            className="bg-muted/50"
          >
            <CardHeader>
              <CardTitle className="grid gap-4 place-items-center">
                {icon}
                {title}
              </CardTitle>
            </CardHeader>
            <CardContent>{description}</CardContent>
          </TransparentCard>
        ))}
      </div>

        <div className="w-full bg-muted/10 rounded-lg p-4 text-center">
            <video 
            controls
            autoPlay 
            loop 
            muted 
            playsInline
            className="w-full mx-auto"
            >
                <source src="/Exchanges-Connect-Kraken.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>

    </section>
  );
};
